import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { AuditShiftTypeModel } from '@/libs/Api';
import { AuditShiftTypesDataService } from '@/libs/audit-shift-types/audit-shift-types-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const auditShiftTypesStore = registerCrudStore<AuditShiftTypeModel, AuditShiftTypeModel>(
    BusinessModule.AuditShiftType,
    new AuditShiftTypesDataService()
);
